/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const CheckFill: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21ZM16.2433 10.669C16.6128 10.2585 16.5795 9.62616 16.169 9.25671C15.7585 8.88725 15.1262 8.92053 14.7567 9.33104L10.9618 13.5476L9.20711 11.7929C8.81658 11.4024 8.18342 11.4024 7.79289 11.7929C7.40237 12.1834 7.40237 12.8166 7.79289 13.2071L10.2929 15.7071C10.4869 15.9011 10.752 16.0069 11.0263 15.9997C11.3005 15.9924 11.5598 15.8729 11.7433 15.669L16.2433 10.669Z'
      fill='currentColor'
    />
  </React.Fragment>
)
